import React from "react";
import { Link } from "react-router-dom";
import Card from "./Card";
import Scale from "./Scale";
import "./FactList.css";

export default ({ factItems }) => {
  return factItems.length ? (
    <div className="fact-list">
      {factItems.map(({ id, escala, contexto, anuncio }, i) => (
        <Card key={i}>
          <Link className="fact-item" to={`verificacion/${id}`}>
            <div className="l-fact-header">
              <div className="fact-item__id">{`N° ${id}`}</div>
            </div>
            <div className="l-fact-main">
              <h3 className={`fact-item__quote scale-color--${escala}`}>
                <span>“ </span>
                {anuncio}
                <span> ”</span>
              </h3>
              <div className="fact-item__context">— {contexto}</div>
            </div>

            <div className="l-fact-footer">
              <div className="fact-item__scale">
                <Scale id={escala} type="legend" />
              </div>
              <div className="btn">Leer informe</div>
            </div>
          </Link>
        </Card>
      ))}
    </div>
  ) : (
    <div className="fact-list">No data</div>
  );
};



// WEBPACK FOOTER //
// ./src/components/FactList.js